import React from 'react'
import { makeStyles,createTheme, ThemeProvider } from '@material-ui/core/styles';
import {Container} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab';

const theme2 = createTheme({
    palette:{
        primary:{
            light:'#041556',
            main:'#001b7b',
            dark: '#374b95',
        },
        secondary:{
            light:'#b26500',
            main:'#ff9100',
            dark: '#ffa733',
        },
        type:'dark',
    }
  });

const useStyles = makeStyles( theme => ({
    container:{
        display: 'flex',
        height: 'auto',
        
        justifyContent:'center',
        flexDirection:'column',
        padding: theme.spacing(6),
        backgroundColor: theme2.palette.primary.main,
      },
  }));



export default function LayoutContainer(props) {
    const classes = useStyles()


    return (
        <ThemeProvider theme={theme2}>
        <Container className={classes.container} maxWidth='sm'>
            {props.children}
        </Container>
        </ThemeProvider>
    )
}
